<div class="MainContainer">
    <div class="MainTitleBar">
        <p class="SectionHalfTitle" style="margin-top: 0%;">{{ 'Payments' | translate }}</p>
        <div class="SectionHalfTitle SectionHalfTitleRight">
          <button mat-button  style="padding-left: 10px;margin-right: 10px;"color="accent" (click)="ShowPCGeneration = true;" *ngIf="ShowPCGeneration != true;">
            <i class="material-icons">add</i>
            {{'GeneratePurchaseContract' | translate}}
          </button>
          <button mat-button  style="padding-left: 10px;margin-right: 10px;"color="warn" *ngIf="ShowPCGeneration == true;" (click)="ShowPCGeneration = false;">
            <i class="material-icons">replay</i>
            {{'Cancel' | translate}}
          </button>
          <button mat-raised-button  style="padding-left: 10px;margin-right: 10px;"color="accent" *ngIf="ShowPCGeneration == true;" (click)="ContinueToPurchaseContract();">
            <i class="material-icons">add</i>
            {{'Continue' | translate}}
          </button>
            <button (click)="OpenBankExtrasImport();" style="padding-left: 10px;margin-right: 10px;" mat-raised-button color="primary"><i class="material-icons">file_download</i> {{'ImportBankExtras' | translate}}</button>
            <button (click)="InitializeNewPayment();" style="padding-left: 10px;margin-right: 10px;" mat-raised-button color="primary"><i class="material-icons">add</i> {{'Payment' | translate}}</button>
          </div>
    </div>

    <div class="animated fadeInDown CashCollectionContainer" style="top:15%!important;width: 30%;left: 40%;" *ngIf="ShowSuggestionPaymentsContainerStepTwo">
        <div class="PopUpCloseContainer" (click)="ShowSuggestionPaymentsContainerStepTwo = false;">
          <i class="material-icons">close</i>
        </div>

        <div class="PopUpTitleContainer">
          <p>{{ 'IMPORTPAYMENTS' | translate }}</p>
         </div>

         <div class="PopUpBody" style="margin-top: 20px;">
            <div class="PopUpBodyInfoRow">
                {{'AssociatedPayments' | translate}}: <span style="color:#32aa3a;font-weight: bold;">{{this.AssociatedPayments.length}}</span>
            </div>
            <div class="PopUpBodyInfoRow">
                {{'UnAssociatedPayments' | translate}}: <span style="color: red;font-weight: bold;">{{this.UnAssociatedPayments.length}}</span>
            </div>
            <div class="PopUpBodyInfoRow">
                
                <label id="example-radio-group-label">{{'PickImportType' | translate}}</label>
                <mat-radio-group
                  aria-labelledby="example-radio-group-label"
                  class="example-radio-group"
                  [(ngModel)]="PImportType">
                  <mat-radio-button class="example-radio-button" *ngFor="let type of this.PaymentImportTypes" [value]="type">
                    {{type.Name}}
                  </mat-radio-button>
                </mat-radio-group>
                <div>{{'ChosenImportType' | translate}}: {{PImportType.Name}}</div>
                
            </div>

            <div class="PopUpBodyInfoRow">
              <mat-slide-toggle [(ngModel)]="DoNotImportDupplicateValues"></mat-slide-toggle>
              <p class="SliderText">
                <span *ngIf="DoNotImportDupplicateValues">{{'DoNotImportDupplicateValues' | translate}}</span>
                <span style="color: #fd4f57;font-weight: 400;" *ngIf="!DoNotImportDupplicateValues">{{'DupplicateValuesWillBeImported' | translate}}</span>
              </p>
            
            </div>
         </div>

         <div class="PopUpCommands">
          <button (click)="ImportPayments();" [disabled]="parent.loading" mat-raised-button color="primary" class="PopGeneralCommandButton">
              <span>{{'AcceptAndSave' | translate}}</span>
        </button>
        </div>
      </div>

    <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowSuggestionPaymentsContainer" style="left: 16%;width: 83%;">
        <div class="PopUpCloseContainer" (click)="ShowSuggestionPaymentsContainer = false;">
          <i class="material-icons">close</i>
        </div>

        <div class="PopUpTitleContainer" style="height: auto;">
          <p>{{ 'DetectedPayments' | translate }}</p>

          <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;width: 95%;margin-left: 2.5%;margin-top: 15px;">
            <div class="ReceptionProductsCol" style="width: 5%;">
              {{ 'Document' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 15%;">
              {{ 'Supplier' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
              {{ 'PaymentDate' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
              {{ 'Value' | translate }} 
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
              {{ 'PaymentType' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 5%;">
                {{ 'Currency' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 5%;">
                {{ 'Receptions.ExchangeRate' | translate }}
              </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
              {{ 'Receptions.DecimalPercision' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 20%;">
                {{ 'CollectionExternalID' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
                {{ 'Actions' | translate }}
            </div>
          </div>
         </div>

         <div class="PopUpBody" style="margin-top: 5px;">

        <div class="ReceptionProductsContainer  top-box">

            <div class="ReceptionProductsRow TotalRow" *ngIf="loading">
                <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
            </div>

            <div *ngIf="!loading">
                <div class="ReceptionProductsRow" *ngFor="let c of this.SuggestedPayments; let i=index;" [ngClass]="{'UnAssociatedPayment': c.Status.ID == -1, 'AssociatedPayment': c.Status.ID == 1, 'DupplicateCC': c.IsDuplicate == true }">
                    <div class="ReceptionProductsCol" style="width: 5%;">
                     <span *ngIf="c.Status.ID == 1;">{{c.DisplayValue}}</span>
                     <span *ngIf="c.Status.ID == -1;">---</span>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 15%;">
                        <span *ngIf="c.Status.ID == 1;">{{c.Supplier.Name}}</span>
                        <span *ngIf="c.Status.ID == -1;">[ {{c.Status.Name}} ]</span>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                      {{c.PaymentDateUI}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                      {{c.Value}} 
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                      {{c.Type.Name}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 5%;">
                        {{c.Currency.Name}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 5%;">
                        <span *ngIf="c.Currency.ExchangeRate > 0;">{{c.Currency.ExchangeRate}}</span>
                        <span *ngIf="c.Currency.ExchangeRate == 0;">---</span>
                      </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                        {{c.Currency.DecimalPrecision.ID}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 20%;">
                        {{c.PaymentExternalID}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                        <i class="material-icons ReceptionProductEdit" (click)="OpenSuggestedPaymentModifier(c); ShowSuggestedPaymentModifier = true;">edit</i>
                        <i class="material-icons ReceptionProductEdit" style="color: red;" (click)="DeleteSuggestedPayment(c);">close</i>
                    </div>
                </div>
            </div>

          
        </div>
        
         </div>

         <div class="PopUpCommands" style="height: auto;min-height: 50px;padding-bottom: 15px;">
            <div *ngIf="this.SuggestedPayments != null && this.SuggestedPayments.length > 0 && !loading;">
                <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngFor="let Total of this.Totals; let i=index;">
                    <div class="ReceptionProductsCol" style="width: 5%;">
                         
                    </div>
                    <div class="ReceptionProductsCol" style="width: 15%;">
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
                        {{this.SuggestedPayments.length}} {{'Payments' | translate}}
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                        Total:
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                      <p>{{Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></p>
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                        {{Total.Currency.Name}}
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                        
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                        
                    </div>
                    <div class="ReceptionProductsCol" style="width: 20%;">
                      
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                        
                    </div>
                </div>
            </div>
          <button (click)="AcceptBankExtrasStepOne();" [disabled]="parent.loading" mat-raised-button color="primary" class="PopGeneralCommandButton RightCommandButton" style="width: auto;">
              <span>{{'AcceptStep' | translate}}</span>
              <i class="material-icons">chevron_right</i>
        </button>
        </div>
    </div>

    <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowBankExtrasImportContainer">
        <div class="PopUpCloseContainer" (click)="ShowBankExtrasImportContainer = false;">
          <i class="material-icons">close</i>
        </div>

        <div class="PopUpTitleContainer">
          <p>{{ 'ImportBankExtras' | translate }}</p>
         </div>

         <div class="PopUpBody" style="margin-top: 20px;">

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
                <mat-select name="AccountNumber" [(ngModel)]="ImportExtrasBankAccount" [compareWith]="compareFn">
                  <mat-option *ngFor="let b of this.BankAccounts;" [value]="b">
                    {{b.DisplayValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div class="ReceptionProductsColDropDown">
                <div style="margin-bottom: 15px;">
                    <input mat-raised-button type="file" formControlName="UploadedFile" (change)="onSelectFile($event)" >
                </div>
              </div>

              <div class="ReceptionProductsColDropDown">
                <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                    <mat-label>{{ 'Delimiter' | translate }}</mat-label>
                    <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.ImportExtrasDelimiter">
                    <mat-icon matSuffix>calculate</mat-icon>
                  </mat-form-field>
              </div>
         
         </div>

         <div class="PopUpCommands">
          <button [disabled]="parent.loading" mat-raised-button color="primary" class="PopGeneralCommandButton" (click)="GetBankExtrasPayments();">
              <span>{{'ImportDocument' | translate}}</span>
        </button>
        </div>
    </div>

    <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowPaymentContainer">
        <div class="PopUpCloseContainer" (click)="ShowPaymentContainer = false;">
          <i class="material-icons">close</i>
        </div>

        <div class="PopUpTitleContainer">
          <p *ngIf="this.currentPayment.ID > 0;">{{ 'UpdatePayment' | translate }}</p>
          <p *ngIf="!this.currentPayment.ID > 0;">{{ 'NewPayment' | translate }}</p>
         </div>

         <div class="PopUpBody" style="margin-top: 20px;">
            
            <div class="currentPaymentRadioGroupContainer">
                <mat-radio-group
                [(ngModel)]="currentPayment.Category">
                <mat-radio-button class="example-radio-button" *ngFor="let c of this.PaymentCategories" [value]="c">
                  {{c.Name}}
                </mat-radio-button>
              </mat-radio-group>
            </div>

            <div *ngIf="this.currentPayment.Category.ID == 0;">
                <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                    <mat-label>{{ 'AssociatedReception' | translate }}*</mat-label>
                    <input *ngIf="!this.currentPayment.ReceptionID.length > 0;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue" (click)="SearchReceptions(this.currentPayment.DisplayValue);" (keyup)="SearchReceptions(this.currentPayment.DisplayValue);">
                    <input disabled="disabled" *ngIf="this.currentPayment.ReceptionID.length > 0;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue">
                    <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="this.currentPayment.ReceptionID.length > 0;" (click)="this.currentPayment.ReceptionID = '';this.currentPayment.DisplayValue = '';this.currentPayment.ReceptionDetailsID = null">close</mat-icon>
                    <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="!this.currentPayment.ReceptionID.length > 0 && Receptions != null;" (click)="this.currentPayment.DisplayValue = ''; Receptions = null">close</mat-icon>
                </mat-form-field>
    
                <div class="InvoiceSearchContainer" *ngIf="Receptions != null;">
                    <div class="InvoiceSearchResult" *ngFor="let r of this.Receptions; let j=index;" (click)="SelectReceptionForPaymentSearch(r);">
                       <div class="InvoiceSearchResultCol">
                        {{r.AccountingNumber.DisplayValue}}
                       </div>
                       <div class="InvoiceSearchResultCol" style="width: 40%;">
                        {{r.Supplier.Name}}
                       </div>
                       <div class="InvoiceSearchResultCol">
                        {{r.EventRegisterUIDate}}
                       </div>
                       <div class="InvoiceSearchResultCol">
                        {{r.Total.TotalQtyPriceVAT}} {{r.Currency.Name}}
                       </div>
                    </div>
                </div>
            </div>

            <div *ngIf="this.currentPayment.Category.ID == 1;">
                <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                    <mat-label>{{ 'AssociatedSpending' | translate }}*</mat-label>
                    <input *ngIf="this.currentPayment.SpendingID == null;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue" (click)="SearchSpendings(this.currentPayment.DisplayValue);" (keyup)="SearchSpendings(this.currentPayment.DisplayValue);">
                    <input disabled="disabled" *ngIf="this.currentPayment.SpendingID != null;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue">
                    <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="this.currentPayment.SpendingID != null;" (click)="this.currentPayment.SpendingID = null;this.currentPayment.DisplayValue = '';this.currentPayment.ReceptionDetailsID = null">close</mat-icon>
                    <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="!this.currentPayment.SpendingID != null && Spendings != null;" (click)="this.currentPayment.DisplayValue = '';this.currentPayment.SpendingID = null;">close</mat-icon>
                </mat-form-field>
    
                <div class="InvoiceSearchContainer" *ngIf="Spendings != null;">
                    <div class="InvoiceSearchResult" *ngFor="let s of this.Spendings; let j=index;" (click)="SelectSpendingForPaymentSearch(s);">
                       <div class="InvoiceSearchResultCol" style="width: 60%;">
                        {{s.Partner.Name}}
                       </div>
                       <div class="InvoiceSearchResultCol">
                        {{s.DocumentDateUI}}
                       </div>
                       <div class="InvoiceSearchResultCol">
                        {{s.Total.TotalQtyPriceVAT}} {{s.Currency.Name}}
                       </div>
                    </div>
                </div>
            </div>

            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'PaymentType' | translate }}</mat-label>
                <mat-select name="PaymentType" [(ngModel)]="currentPayment.Type" [compareWith]="compareFn">
                  <mat-option *ngFor="let type of this.PaymentTypes;" [value]="type">
                    {{type.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'Currency' | translate }}</mat-label>
                <mat-select name="Currency" [(ngModel)]="currentPayment.Currency" [compareWith]="compareFn">
                  <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="ReselectBankAccount(c);">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
                <mat-select name="AccountNumber" [(ngModel)]="currentPayment.BankAccount" [compareWith]="compareFn">
                  <mat-option *ngFor="let b of this.BankAccounts;" [value]="b">
                    {{b.DisplayValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" style="width: 100%;padding: 0;" *ngIf="this.currentPayment.Currency.ExchangeRate > 0;">
                <mat-label>{{ 'Receptions.ExchangeRate' | translate }}</mat-label>
                <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Currency.ExchangeRate">
                <mat-icon matSuffix>calculate</mat-icon>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
                <mat-select name="DecimalPercision" [(ngModel)]="currentPayment.Currency.DecimalPrecision" [compareWith]="compareFn">
                  <mat-option *ngFor="let d of this.DecimalPrecisions;" [value]="d">
                    {{d.Meaning}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

          <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
            <mat-label>{{ 'PaymentDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp3" [formControl]="CollectionDate" [(ngModel)]="this.currentPayment.PaymentDate">
            <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
            <mat-datepicker #dp3></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
            <mat-label>{{ 'PaymentValue' | translate }}* [{{this.currentPayment.Currency.Name}}]</mat-label>
            <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Value" (change)="VerifyPriceModel(this.currentPayment.Value);">
            <mat-icon matSuffix>monetization_on</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
            <mat-label>{{ 'PaymentExternalID' | translate }}</mat-label>
            <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.PaymentExternalID">
            <mat-icon matSuffix>qr_code_2</mat-icon>
          </mat-form-field>
         </div>

         <div class="PopUpCommands">
          <button *ngIf="this.currentPayment.ID > 0;" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="UpdatePayment(this.currentPayment);ShowPaymentContainer = false;">
              <span>{{'UpdatePayment' | translate}}</span>
        </button>
        <button *ngIf="!this.currentPayment.ID > 0;" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="AddPayment();ShowPaymentContainer = false;">
            <span>{{'AddPayment' | translate}}</span>
      </button>
        </div>
    </div>

      <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowSuggestedPaymentModifier">
        <div class="PopUpCloseContainer" (click)="ShowSuggestedPaymentModifier = false;">
          <i class="material-icons">close</i>
        </div>

        <div class="PopUpTitleContainer">
          <p *ngIf="this.currentPayment.ID > 0;">{{ 'UpdatePayment' | translate }}</p>
          <p *ngIf="!this.currentPayment.ID > 0;">{{ 'NewPayment' | translate }}</p>
         </div>

         <div class="PopUpBody" style="margin-top: 20px;">
            
            <div class="currentPaymentRadioGroupContainer">
                <mat-radio-group
                [(ngModel)]="currentPayment.Category">
                <mat-radio-button class="example-radio-button" *ngFor="let c of this.PaymentCategories" [value]="c">
                  {{c.Name}}
                </mat-radio-button>
              </mat-radio-group>
            </div>

            <div *ngIf="this.currentPayment.Category.ID == 0;">
                <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                    <mat-label>{{ 'AssociatedReception' | translate }}*</mat-label>
                    <input *ngIf="!this.currentPayment.ReceptionID.length > 0;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue" (click)="SearchReceptions(this.currentPayment.DisplayValue);" (keyup)="SearchReceptions(this.currentPayment.DisplayValue);">
                    <input disabled="disabled" *ngIf="this.currentPayment.ReceptionID.length > 0;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue">
                    <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="this.currentPayment.ReceptionID.length > 0;" (click)="this.currentPayment.ReceptionID = '';this.currentPayment.DisplayValue = '';this.currentPayment.ReceptionDetailsID = null">close</mat-icon>
                    <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="!this.currentPayment.ReceptionID.length > 0 && Receptions != null;" (click)="this.currentPayment.DisplayValue = ''; Receptions = null">close</mat-icon>
                </mat-form-field>
    
                <div class="InvoiceSearchContainer" *ngIf="Receptions != null;">
                    <div class="InvoiceSearchResult" *ngFor="let r of this.Receptions; let j=index;" (click)="SelectReceptionForPaymentSearch(r);">
                       <div class="InvoiceSearchResultCol">
                        {{r.AccountingNumber.DisplayValue}}
                       </div>
                       <div class="InvoiceSearchResultCol" style="width: 40%;">
                        {{r.Supplier.Name}}
                       </div>
                       <div class="InvoiceSearchResultCol">
                        {{r.EventRegisterUIDate}}
                       </div>
                       <div class="InvoiceSearchResultCol">
                        {{r.Total.TotalQtyPriceVAT}} {{r.Currency.Name}}
                       </div>
                    </div>
                </div>
            </div>

            <div *ngIf="this.currentPayment.Category.ID == 1;">
                <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                    <mat-label>{{ 'AssociatedSpending' | translate }}*</mat-label>
                    <input *ngIf="this.currentPayment.SpendingID == null;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue" (click)="SearchSpendings(this.currentPayment.DisplayValue);" (keyup)="SearchSpendings(this.currentPayment.DisplayValue);">
                    <input disabled="disabled" *ngIf="this.currentPayment.SpendingID != null;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue">
                    <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="this.currentPayment.SpendingID != null;" (click)="this.currentPayment.SpendingID = null;this.currentPayment.DisplayValue = '';this.currentPayment.ReceptionDetailsID = null">close</mat-icon>
                    <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="!this.currentPayment.SpendingID != null && Spendings != null;" (click)="this.currentPayment.DisplayValue = '';this.currentPayment.SpendingID = null;">close</mat-icon>
                </mat-form-field>
    
                <div class="InvoiceSearchContainer" *ngIf="Spendings != null;">
                    <div class="InvoiceSearchResult" *ngFor="let s of this.Spendings; let j=index;" (click)="SelectSpendingForPaymentSearch(s);">
                       <div class="InvoiceSearchResultCol" style="width: 60%;">
                        {{s.Partner.Name}}
                       </div>
                       <div class="InvoiceSearchResultCol">
                        {{s.DocumentDateUI}}
                       </div>
                       <div class="InvoiceSearchResultCol">
                        {{s.Total.TotalQtyPriceVAT}} {{s.Currency.Name}}
                       </div>
                    </div>
                </div>
            </div>

            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'PaymentType' | translate }}</mat-label>
                <mat-select name="PaymentType" [(ngModel)]="currentPayment.Type" [compareWith]="compareFn">
                  <mat-option *ngFor="let type of this.PaymentTypes;" [value]="type">
                    {{type.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'Currency' | translate }}</mat-label>
                <mat-select name="Currency" [(ngModel)]="currentPayment.Currency" [compareWith]="compareFn">
                  <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="ReselectBankAccount(c);">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
                <mat-select name="AccountNumber" [(ngModel)]="currentPayment.BankAccount" [compareWith]="compareFn">
                  <mat-option *ngFor="let b of this.BankAccounts;" [value]="b">
                    {{b.DisplayValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" style="width: 100%;padding: 0;" *ngIf="this.currentPayment.Currency.ExchangeRate > 0;">
                <mat-label>{{ 'Receptions.ExchangeRate' | translate }}</mat-label>
                <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Currency.ExchangeRate">
                <mat-icon matSuffix>calculate</mat-icon>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
                <mat-select name="DecimalPercision" [(ngModel)]="currentPayment.Currency.DecimalPrecision" [compareWith]="compareFn">
                  <mat-option *ngFor="let d of this.DecimalPrecisions;" [value]="d">
                    {{d.Meaning}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

          <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
            <mat-label>{{ 'PaymentDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp3" [formControl]="CollectionDate" [(ngModel)]="currentPayment.PaymentDate">
            <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
            <mat-datepicker #dp3></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
            <mat-label>{{ 'PaymentValue' | translate }}* [{{this.currentPayment.Currency.Name}}]</mat-label>
            <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Value" (change)="VerifyPriceModel(this.currentPayment.Value);">
            <mat-icon matSuffix>monetization_on</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
            <mat-label>{{ 'PaymentExternalID' | translate }}</mat-label>
            <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.PaymentExternalID">
            <mat-icon matSuffix>qr_code_2</mat-icon>
          </mat-form-field>
         </div>

         <div class="PopUpCommands">
          <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="ShowSuggestedPaymentModifier = false;">
              <span>{{'UpdatePayment' | translate}}</span>
        </button>
        </div>
      </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteSpendingQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDeleteSpendingQuestion = false; currentSpending = null;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>

      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteSpendingQuestion = false; currentPayment = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteSpendingQuestion = false;DeletePayment(currentPayment.ID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

    <div class="overlay" *ngIf="ShowSuggestionPaymentsContainerStepTwo || ShowSuggestionPaymentsContainer || ShowBankExtrasImportContainer || showEditSpendingPopUp || ShowDeleteSpendingQuestion || ShowPaymentContainer;" (click)="showEditSpendingPopUp = false; ShowDeleteSpendingQuestion = false;"></div>

    <div class="MainTitleBar" style="overflow: hidden;">
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
            <mat-select name="Administration" [(ngModel)]="Filter.Period">
              <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="AddActiveFilter(a.Name, 'Period'); GetPaymentsFiltered();">
                {{a.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
            <mat-datepicker #dp1></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="FifteenPercentContainer" style="margin-top: -4px;">
            <button mat-mini-fab aria-label="Example icon button with a home icon" color="primary" (click)="GetPaymentsFiltered();">
              <mat-icon>filter_alt</mat-icon>
            </button>
        </div>
      
      </div>

      <div class="MainTitleBar" style="overflow: unset;">
        <div class="FilterButton noselect" (click)="this.showFilter = !this.showFilter;">
            <i class="material-icons">filter_alt</i>
            <span>Filter</span>
        </div>
    
        <div class="ActiveFiltersContainer">
          <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
            {{a.Name}}
            <i class="material-icons">close</i>
          </div>
        </div>
    
        <div class="FilterContainer animated fadeIn" *ngIf="showFilter">
            <div class="FilterCloseContainer" (click)="this.showFilter = false;">
                <i class="material-icons">close</i>
            </div>
    
            <div class="FilterContainerBody">
    
                <div class="PopUpBodyRow">
                  
                </div>
                 
                <div class="PopUpBodyOneThirddContainer">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                        <mat-label>Doc.Status</mat-label>
                        <mat-select name="Series" [(ngModel)]="Filter.DocumentStatus">
                          <mat-option *ngFor="let d of this.DocumentStatuses;" [value]="d" (click)="AddActiveFilter(d.Name, 'DocStatus');">
                            {{d.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>

                <div class="PopUpBodyOneThirddContainer">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                        <mat-label>{{'Currency' | translate}}</mat-label>
                        <mat-select name="Currency" [(ngModel)]="Filter.Currency">
                          <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="AddActiveFilter(c.Name, 'Currency');">
                            {{c.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>

                <div class="PopUpBodyOneThirddContainer">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                        <mat-label>{{'AccountNumber' | translate}}</mat-label>
                        <mat-select name="Currency" [(ngModel)]="Filter.BankAccount">
                          <mat-option *ngFor="let b of this.BankAccounts;" [value]="b" (click)="AddActiveFilter(b.DisplayValue, 'BankAccount');">
                            {{b.DisplayValue}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>
    
                <div class="PopUpBodyTwoThirdsContainer">
                    <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                        <mat-label>{{ 'SearchClient' | translate }}*</mat-label>
                        <input matInput placeholder="Name/VAT" autocomplete="off" [(ngModel)]="this.searchTerm" (ngModelChange)="GetPartnersFiltered(this.searchTerm, this.countryID, true);">
                        <mat-icon matSuffix (click)="GetPartnersFiltered(this.searchTerm, this.countryID, true);" style="cursor: pointer;" *ngIf="this.partner == null;">search</mat-icon>
                        <i class="material-icons searchCloseButton" *ngIf="this.searchTerm" (click)="this.searchTerm=''; this.Partners.length = 0;resultsLength = 0; this.partner = null; this.Filter.Partner = null;">close</i>
                      </mat-form-field>
    
                      <div class="PartnerSearchResultsContainer" *ngIf="resultsLength > 0;">
                        <div class="PartnerSearchResult" *ngFor="let p of Partners" (click)="this.partner = p;resultsLength = 0;this.searchTerm=p.Name;this.Filter.Partner = p;AddActiveFilter(p.Name, 'Partner');">
                            <p class="SearchResultTitle">{{p.Name}} <span style="font-weight: bold;" *ngIf="p.VAT.length;">{{p.VAT}}</span></p>
                        </div>
                      </div>
                </div>

                <div class="PopUpBodyOneThirddContainer">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                        <mat-label>{{'PaymentType' | translate}}</mat-label>
                        <mat-select name="Country" [(ngModel)]="Filter.Type">
                          <mat-option *ngFor="let t of this.PaymentTypes;" [value]="t" (click)="AddActiveFilter(t.Name, 'Type');">
                            {{t.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>
              
            </div>
            
            <div class="FilterCommands">
                <button mat-raised-button color="primary" class="FilterButtonAction" (click)="GetPaymentsFiltered();">{{ 'FilterInvoices' | translate }}</button>
            </div>
        </div>

        <div class="TotalDocCountContainer" *ngIf="this.Payments != undefined;">
            <span style="float: right;">{{this.Payments.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'Payments' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})</span>
            <div class="PageSizeContainer">
              <mat-form-field appearance="outline" class="PageSizeTextBox">
                <mat-label>{{ 'PageSize' | translate }}*</mat-label>
                <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="GetPaymentsFiltered(1);">
              </mat-form-field>
            </div>
          </div>

          <div class="TotalDocCountContainer">
            <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetPaymentsFiltered(this.Filter.Pager.PageIndex - 1);">
              <i class="material-icons">chevron_left</i>
            </div>
            <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
              <i class="material-icons">chevron_left</i>
            </div>
  
            <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetPaymentsFiltered(this.Filter.Pager.PageIndex + 1);">
              <i class="material-icons">chevron_right</i>
            </div>
            <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
              <i class="material-icons">chevron_right</i>
            </div>
          </div>
    </div>

    <div class="MainTitleBar" style="overflow: unset;" *ngIf="ShowPCGeneration == true;">
      <div class="ReceptionProductsCol NewPCInstructions" style="width: 5%;">
        <i class="material-icons NewPCInstructionsIcon">arrow_drop_down_circle</i>
      </div>  
      <div class="ReceptionProductsCol NewPCInstructions" style="width: 95%;text-align: left;">
        {{'PaymentsNewPurchaseContractInstructions' | translate}}
      </div>  
    </div>

    <div class="MainBody">

        <div class="ReceptionProductsContainer">
          
            <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;">
              <div class="ReceptionProductsCol" style="width: 5%;">
                   
              </div>  
              <div class="ReceptionProductsCol" style="width: 5%;">
                    {{ 'Category' | translate }}
                  </div>
                <div class="ReceptionProductsCol" style="width: 15%;">
                  {{ 'Supplier' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                  {{ 'PaymentDate' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                  {{ 'Value' | translate }} 
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                  {{ 'PaymentType' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                    {{ 'Currency' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                    {{ 'Receptions.ExchangeRate' | translate }}
                  </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                  {{ 'Receptions.DecimalPercision' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;">
                    {{ 'CollectionExternalID' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                    {{ 'Actions' | translate }}
                </div>
            </div>

            <div class="ReceptionProductsRow TotalRow" *ngIf="loading">
                <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
            </div>

            <div *ngIf="!loading">
                <div class="ReceptionProductsRow" *ngFor="let c of this.Payments; let i=index;" [ngClass]="{'UnAssociatedPayment': c.Category.ID == -1, 'AssociatedPayment': c.Category.ID == 0, 'AssociatedSpending': c.Category.ID == 1}">
                  
                  <div class="ReceptionProductsCol" style="width: 5%;">
                    <mat-checkbox class="example-margin" [(ngModel)]="c.IsSelected" *ngIf="ShowPCGeneration" [disabled]="c.Category.ID != -1" (change)="SelectPayment(c);"></mat-checkbox>
                  </div>
                  
                  <div class="ReceptionProductsCol" style="width: 5%;">
                        <span *ngIf="c.Category.ID == 0;" class="PaymentCategory">{{c.DisplayValue}}</span>
                        <span *ngIf="c.Category.ID == 1;" class="PaymentCategory">{{c.Category.Name}}</span>
                      </div>
                    <div class="ReceptionProductsCol" style="width: 15%;">
                        <span *ngIf="c.Status.ID == 1;">{{c.Supplier.Name}}</span>
                        <span *ngIf="c.Status.ID == -1;color">[ {{c.Status.Name}} ]</span>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                      {{c.PaymentDateUI}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                      {{c.Value}} 
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                      {{c.Type.Name}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 5%;">
                        {{c.Currency.Name}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 5%;">
                        <span *ngIf="c.Currency.ExchangeRate > 0;">{{c.Currency.ExchangeRate}}</span>
                        <span *ngIf="c.Currency.ExchangeRate == 0;">---</span>
                      </div>
                    <div class="ReceptionProductsCol" style="width: 5%;">
                        {{c.Currency.DecimalPrecision.ID}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 20%;">
                        {{c.PaymentExternalID}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                        <i class="material-icons ReceptionProductEdit" (click)="ClonePayment(c); ShowPaymentContainer = true;">edit</i>
                        <i class="material-icons ReceptionProductEdit" style="color: red;" (click)="ClonePayment(c); ShowDeleteSpendingQuestion = true;">close</i>
                    </div>
                </div>
            </div>

            <div *ngIf="this.Payments != null && this.Payments.length > 0 && !loading;">
                <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngFor="let Total of this.Totals; let i=index;">
                    <div class="ReceptionProductsCol" style="width: 10%;">
        
                    </div>
                    <div class="ReceptionProductsCol" style="width: 15%;">
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                        Total:
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                      <p>{{Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></p>
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                        {{Total.Currency.Name}}
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                        
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                        
                    </div>
                    <div class="ReceptionProductsCol" style="width: 20%;">
                      
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                        
                    </div>
                </div>
            </div>

            <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="!loading && Payments.length > 0;">
                <div class="ReceptionProductsCol" style="width: 10%;">
          
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;">
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
                </div>
                <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                  <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetPaymentsFiltered(this.Filter.Pager.PageIndex - 1);">
                    <i class="material-icons">chevron_left</i>
                  </button>
          
                  <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;cursor: not-allowed;">
                    <i class="material-icons">chevron_left</i>
                  </button>
                </div>
                <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                  {{this.Filter.Pager.PageIndex}} / {{this.Filter.Pager.Pages}}
                </div>
                <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                  <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetPaymentsFiltered(this.Filter.Pager.PageIndex + 1);">
                    <i class="material-icons">chevron_right</i>
                  </button>
          
                  <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;cursor: not-allowed;">
                    <i class="material-icons">chevron_right</i>
                  </button>
                </div>
                <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                    
                </div>
                <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                    
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;">
                    
                </div>
                <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                    
                </div>
            </div>
     
        </div>
    
    </div>
</div>